import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';

import { getValidationErrors } from './validationHelpers';

const useValidation = () => {
	const fieldInfo = useSelector(contractGeneratorSelectors.getFieldInfo);
	const validationErrors = getValidationErrors(fieldInfo);

	return {
		validationErrors
	};
};

export default useValidation;
